import { Eye, EyeOff, LockKeyhole, UserRound } from "lucide-react";
import { FormEvent, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import { login, MARKET_TOKEN_KEY } from "@/api/auth";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [account, setAccount] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(location.state?.message || (location.state?.registered ? "注册成功，请使用账号登录" : ""));

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!account.trim() || !password) {
      setError("请输入账号和密码");
      return;
    }
    setError("");
    setLoading(true);
    try {
      const token = await login(account.trim(), password);
      localStorage.setItem(MARKET_TOKEN_KEY, token);
      localStorage.removeItem("market_access");
      localStorage.setItem("workspace_origin", "market");
      navigate("/workspace", { replace: true });
    } catch (err) {
      localStorage.removeItem(MARKET_TOKEN_KEY);
      localStorage.removeItem("market_access");
      setError(err instanceof Error ? err.message : "登录失败，请稍后重试");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="账号登录" subtitle="使用注册时的账号与密码登录平台，登录后即可进入工作台。">
      <form onSubmit={handleSubmit} className="space-y-5" noValidate>
        <label className="block"><span className="mb-2 block text-sm font-medium text-foreground-700">账号</span><span className="relative block"><UserRound size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400" /><input value={account} onChange={(event) => setAccount(event.target.value)} placeholder="请输入账号" autoComplete="username" className="h-12 w-full rounded-xl border border-background-300 bg-background-50 pl-11 pr-4 text-sm outline-none transition focus:border-primary-500 focus:ring-4 focus:ring-primary-500/10" /></span></label>
        <label className="block"><span className="mb-2 block text-sm font-medium text-foreground-700">密码</span><span className="relative block"><LockKeyhole size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400" /><input type={showPassword ? "text" : "password"} value={password} onChange={(event) => setPassword(event.target.value)} placeholder="请输入密码" autoComplete="current-password" className="h-12 w-full rounded-xl border border-background-300 bg-background-50 pl-11 pr-12 text-sm outline-none transition focus:border-primary-500 focus:ring-4 focus:ring-primary-500/10" /><button type="button" onClick={() => setShowPassword((value) => !value)} className="absolute right-3 top-1/2 -translate-y-1/2 p-1 text-foreground-400 hover:text-foreground-700" aria-label={showPassword ? "隐藏密码" : "显示密码"}>{showPassword ? <EyeOff size={18} /> : <Eye size={18} />}</button></span></label>
        {error && <p className={`rounded-lg px-3 py-2 text-sm ${location.state?.registered && !loading ? "bg-green-50 text-green-700" : "bg-red-50 text-red-600"}`} role="alert">{error}</p>}
        <button type="submit" disabled={loading} className="h-12 w-full rounded-xl bg-primary-500 text-sm font-bold text-white shadow-lg shadow-primary-500/20 transition hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60">{loading ? "登录中…" : "登录"}</button>
      </form>
      <p className="mt-6 text-center text-sm text-foreground-500">还没有账号？ <Link to="/register" className="font-semibold text-primary-600 hover:text-primary-700">立即注册</Link></p>
    </AuthShell>
  );
}
